import type { Components } from "@mui/material/styles";

export const MuiAccordion: Components["MuiAccordion"] = {
    defaultProps: {
        disableGutters: true,
        square: true,
    },
    styleOverrides: {
        root: {
            width: "100%",
            backgroundColor: "unset",
            boxShadow: "none",
            borderBottom: "1px solid",
            borderColor: "var(--mui-palette-gray-200)",

            "&.Mui-expanded:before": {
                opacity: "1",
            },
            "&::before": {
                content: "unset",
            },
        },
    },
};

export const MuiAccordionSummary: Components["MuiAccordionSummary"] = {
    defaultProps: {
        variant: "medium",
    },
    styleOverrides: {
        root: {
            padding: "24px 0",
            alignItems: "flex-start",

            "&:hover": {
                color: "var(--mui-palette-gray-600)",

                "& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root": {
                    color: "var(--mui-palette-gray-600)",
                },
            },

            "&.Mui-focusVisible": {
                outline: "2px solid var(--mui-palette-gray-800)",
                backgroundColor: "inherit",
            },
            "&:active": {
                color: "var(--mui-palette-gray-900)",
            },
            variants: [
                {
                    props: { variant: "small" },
                    style: {
                        padding: "16px 0",
                    },
                },
            ],
        },
        content: {
            margin: 0,
            fontSize: "16px",
            variants: [
                {
                    props: { variant: "large" },
                    style: {
                        fontSize: "18px",
                    },
                },
            ],
        },
        expandIconWrapper: {
            width: "24px",
            height: "24px",
            marginLeft: "8px",

            "& .MuiSvgIcon-root": {
                width: "24px",
                height: "24px",
                color: "var(--mui-palette-gray-800)",
            },
        },
    },
};

export const MuiAccordionDetails: Components["MuiAccordionDetails"] = {
    styleOverrides: {
        root: {
            padding: "4px 0 16px 0",
        },
    },
};
